export const XFactionRampSvg = ({
  color,
  height,
}: {
  color: string;
  height: number;
}) => {
  return (
    <svg
      width={(height / 159) * 82}
      height={height}
      viewBox="0 0 82 159"
      fill="none"
    >
      <rect x="1" y="137" width="80" height="21" fill="#C4C4C4" />
      <rect
        x="1"
        y="1"
        width="80"
        height="72"
        fill="url(#paint0_linear_256_25)"
      />
      <path d="M1 73V137H81V73L41 61.5L1 73Z" fill={color} />
      <path d="M1 25L41 13L81 25" stroke="black" />
      <path d="M1 49L41 37L81 49" stroke="black" />
      <path d="M1 73L41 61L81 73" stroke="#E7BD27" />
      <path d="M1 97L41 85L81 97" stroke="black" />
      <path d="M1 121L41 109L81 121" stroke="black" />
      <path d="M1 137H81" stroke="black" />
      <path d="M81 158H1V1H81V158Z" stroke="black" />
      <defs>
        <linearGradient
          id="paint0_linear_256_25"
          x1="41"
          y1="1"
          x2="41"
          y2="73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6CF5C" />
          <stop offset="1" stopColor="#9E891A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
